import React, { useContext } from "react";
import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";

const EsBlogCard = ({ blog }) => {
  const { baseUrlForFile ,setSelectedPostFromLandingPage} = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <Col lg={4} md={4} sm={12} key={blog.id}>
      <div className="estatica-blog__card">
        {/* Image */}
        <div className="estatica-blog__img-wrapper">
          <img src={`${baseUrlForFile}/${blog.image}`} alt={blog.title} />
        </div>

        {/* Meta */}
        <p className="estatica-blog__meta">
          {blog.date} &nbsp;·&nbsp; {blog.readTime}
        </p>

        {/* Title */}
        <h4 className="estatica-blog__title">{blog.title}</h4>

        {/* Excerpt */}
        <p className="estatica-blog__excerpt">{blog.excerpt}</p>

        <button
          className="estatica-blog__btn"
          onClick={() => {
            navigate("/blog-detailpage");
            setSelectedPostFromLandingPage(blog);
          }}
        >
          View Detail →
        </button>
      </div>
    </Col>
  );
};
export default EsBlogCard;
